<app-menu></app-menu>

<section class="controlflow-editor">
  <header class="editor-header">
    <div>
      <p>Workflows / Cadastro</p>
      <h1>{{ isAssistantWorkflow ? 'Workflow ChatBot' : (workflowId ? 'Editar workflow' : 'Novo workflow') }}</h1>
      <small *ngIf="isAssistantWorkflow">
        Configure etapas, texto, timeout, próximo passo e integrações do bot direto no ControlFlow.
      </small>
      <small *ngIf="!isAssistantWorkflow">
        Desenhe o fluxo e defina as etapas que serão executadas automaticamente.
      </small>
    </div>
    <div class="actions">
      <span class="workflow-feedback" *ngIf="workflowSaved">Workflow salvo.</span>
      <button class="btn ghost" type="button" routerLink="/controlflow">Voltar</button>
      <button
        class="btn primary"
        type="button"
        (click)="saveWorkflow()"
        [disabled]="savingWorkflow || (isAssistantWorkflow && !assistantCommandId)">
        {{ savingWorkflow ? 'Salvando...' : 'Salvar workflow' }}
      </button>
    </div>
  </header>

  <div class="assistant-layout" *ngIf="isAssistantWorkflow; else genericWorkflowTpl">
    <div class="assistant-left">
      <div class="form-card">
        <label>Nome do workflow
          <input type="text" [(ngModel)]="workflowName" placeholder="Ex: ControlAI · Processos | GCB - Cartões">
        </label>
        <label>Tipo do workflow
          <select [(ngModel)]="workflowType" (change)="onWorkflowTypeChange()">
            <option value="PROCESS">Processo</option>
            <option value="CHATBOT">ChatBot</option>
          </select>
        </label>
        <label *ngIf="isAssistantWorkflow">IA_COMANDO
          <select [(ngModel)]="assistantCommandId">
            <option [ngValue]="null">Selecione um comando da tenant</option>
            <option *ngFor="let item of assistantCommands" [ngValue]="item.id">
              #{{ item.id }} · {{ item.title }} · v{{ item.version }}
            </option>
          </select>
        </label>
        <p class="hint" *ngIf="loadingAssistantCommands">Carregando comandos IA...</p>
        <p class="hint">Cada etapa representa um estado do assistente no chat.</p>
      </div>

      <div class="assistant-stages-card">
        <div class="assistant-stages-header">
          <strong>Etapas do assistente</strong>
          <button type="button" class="btn tiny" (click)="addAssistantStage()">+ Nova etapa</button>
        </div>
        <div class="assistant-stage-list">
          <button
            type="button"
            class="assistant-stage-item"
            draggable="true"
            *ngFor="let stage of assistantStages; let i = index"
            [class.active]="selectedAssistantStageIndex === i"
            [class.dragging]="draggingAssistantStageIndex === i"
            [class.drag-over]="assistantStageDragOverIndex === i && draggingAssistantStageIndex !== i"
            (dragstart)="onAssistantStageDragStart(i, $event)"
            (dragover)="onAssistantStageDragOver(i, $event)"
            (drop)="onAssistantStageDrop(i, $event)"
            (dragend)="onAssistantStageDragEnd()"
            (click)="selectAssistantStage(i)">
            <div class="assistant-stage-main">
              <span class="drag-handle" title="Arrastar para reordenar etapas">⋮⋮</span>
            <div>
              <small>{{ getAssistantStageNumberLabel(i) }}</small>
              <strong>{{ getAssistantStageSummary(stage, i) }}</strong>
              <small>{{ stage.id }}</small>
            </div>
            </div>
            <span>{{ getAssistantStageTypeLabel(stage) }} · {{ stage.buttons.length }} botões</span>
          </button>
        </div>
      </div>
    </div>

    <aside class="assistant-right">
      <ng-container *ngIf="selectedAssistantStage as stage">
        <section class="panel-card">
          <header>
            <h4>Editar etapa {{ selectedAssistantStageIndex + 1 }}</h4>
            <small>Defina o conteúdo e as ações dessa etapa.</small>
          </header>

          <div class="panel-form">
            <div class="stage-top-actions">
              <label>ID_ETAPA
                <input
                  type="text"
                  [(ngModel)]="stage.id"
                  placeholder="Ex: AWAITING_SCOPE"
                  (blur)="onAssistantStageIdBlur(stage)">
              </label>
              <button
                type="button"
                class="btn ghost"
                (click)="duplicateAssistantStage(selectedAssistantStageIndex)">
                Duplicar etapa
              </button>
              <button
                type="button"
                class="btn ghost danger"
                [disabled]="assistantStages.length <= 1"
                (click)="removeAssistantStage(selectedAssistantStageIndex)">
                Excluir etapa
              </button>
            </div>

            <label>NOME_ETAPA
              <input type="text" [(ngModel)]="stage.title" placeholder="Título exibido para gestão do fluxo">
            </label>

            <label>TEXTO_DE_ENVIO
              <textarea rows="4" [(ngModel)]="stage.text" placeholder="Mensagem enviada ao usuário"></textarea>
            </label>

            <label>OUTPUT DA ETAPA
              <textarea rows="2" [(ngModel)]="stage.output" placeholder="Registro interno de output"></textarea>
            </label>

            <label>TIPO ETAPA
              <select [(ngModel)]="stage.stage_type" (change)="onAssistantStageTypeChange(stage)">
                <option value="INTERACTION">Interação</option>
                <option value="EXECUTE_API">Executar API</option>
                <option value="TIMER">Timer</option>
              </select>
            </label>

            <ng-container *ngIf="stage.stage_type !== 'INTERACTION'">
              <label>TIME_OUT (segundos)
                <input type="number" min="5" max="3600" step="1" [(ngModel)]="stage.timeout_seconds">
              </label>
              <label *ngIf="stage.stage_type === 'EXECUTE_API'">RESPONSE_EXECUTE_API
                <textarea
                  rows="2"
                  [(ngModel)]="stage.response_execute_api"
                  placeholder="Ex: Processo concluído. Resultado: [response.status] · Score: [response.score]">
                </textarea>
              </label>
              <label>Output de falha/timeout
                <input type="text" [(ngModel)]="stage.failure_output" placeholder="Ex: Não foi possível concluir a execução.">
              </label>
              <label>PROXIMA_TIME_OUT
                <select [(ngModel)]="stage.timeout_next_state" (change)="onAssistantTimeoutNextStateBlur(stage)">
                  <option [value]="noActionState">Não fazer nada (manter etapa)</option>
                  <option *ngFor="let nextStateId of getAssistantNextStateOptions(selectedAssistantStageIndex)" [value]="nextStateId">
                    {{ nextStateId }}
                  </option>
                </select>
              </label>
              <label>Output de cancelamento
                <input type="text" [(ngModel)]="stage.cancel_output" placeholder="Ex: Processamento encerrado pelo analista.">
              </label>
              <label class="checkbox-row">
                <input type="checkbox" [(ngModel)]="stage.allow_cancel_processing">
                Permitir encerrar processamento no chat
              </label>
            </ng-container>

            <label>PROXIMA_ETAPA
              <select [(ngModel)]="stage.default_next_state" (change)="onAssistantDefaultNextStateBlur(stage)">
                <option [value]="noActionState">Não fazer nada (manter etapa)</option>
                <option *ngFor="let nextStateId of getAssistantNextStateOptions(selectedAssistantStageIndex)" [value]="nextStateId">
                  {{ nextStateId }}
                </option>
              </select>
            </label>

            <div class="assistant-buttons-block">
              <div class="assistant-buttons-header">
                <strong>Botões e próximas ações</strong>
                <button type="button" class="btn tiny" (click)="addAssistantButton(stage)">+ Novo botão</button>
              </div>

              <div class="assistant-button-item" *ngFor="let button of stage.buttons; let buttonIndex = index">
                <div class="assistant-button-grid">
                  <label>Texto do botão
                    <input type="text" [(ngModel)]="button.label" placeholder="Ex: Sim">
                  </label>
                  <label>Ação
                    <input
                      type="text"
                      [(ngModel)]="button.action"
                      placeholder="Ex: START_YES"
                      (blur)="onAssistantButtonActionBlur(button)">
                  </label>
                  <label>Próxima etapa
                    <input
                      type="text"
                      [(ngModel)]="button.next_state"
                      placeholder="Ex: AWAITING_REFERENCE"
                      (blur)="onAssistantButtonNextStateBlur(button)">
                  </label>
                  <label>Output do botão
                    <input type="text" [(ngModel)]="button.output" placeholder="Registro desta escolha">
                  </label>
                </div>
                <div class="assistant-button-actions">
                  <button type="button" class="btn ghost danger" (click)="removeAssistantButton(stage, buttonIndex)">
                    Remover botão
                  </button>
                </div>
              </div>

              <p class="hint" *ngIf="!stage.buttons.length">
                Esta etapa ainda não possui botões. Se for encerramento, pode deixar sem botões.
              </p>
            </div>
          </div>
        </section>
      </ng-container>
    </aside>
  </div>

  <ng-template #genericWorkflowTpl>
    <div class="editor-body form-layout">
      <div class="editor-left">
      <div class="form-card">
        <label>Nome do workflow
          <input type="text" [(ngModel)]="workflowName" placeholder="Ex: Onboarding de projeto">
        </label>
        <label>Tipo do workflow
          <select [(ngModel)]="workflowType" (change)="onWorkflowTypeChange()">
            <option value="PROCESS">Processo</option>
            <option value="CHATBOT">ChatBot</option>
          </select>
        </label>
        <label *ngIf="isAssistantWorkflow">IA_COMANDO
          <select [(ngModel)]="assistantCommandId">
            <option [ngValue]="null">Selecione um comando da tenant</option>
            <option *ngFor="let item of assistantCommands" [ngValue]="item.id">
              #{{ item.id }} · {{ item.title }} · v{{ item.version }}
            </option>
          </select>
        </label>
        <p class="hint">Defina a sequência passo a passo para montar o fluxo.</p>
      </div>

        <div class="sequence-builder">
          <div class="sequence-row" *ngFor="let row of rows; let rowIndex = index">
            <div
              class="sequence-step"
              *ngFor="let step of row; let colIndex = index"
              (click)="selectStep(step)"
              [class.active]="selectedStep?.id === step.id">
              <div class="step-header">
                <div class="step-title">
                  <strong>{{ typeLabel(step.type) }}</strong>
                  <span class="step-status" *ngIf="step.status === 'ATIVO'">Ativo</span>
                </div>
                <div class="step-buttons">
                  <button
                    *ngIf="step.status === 'ATIVO'"
                    type="button"
                    class="edit-btn"
                    (click)="selectStep(step); $event.stopPropagation()">Editar</button>
                  <button
                    *ngIf="step.status === 'ATIVO'"
                    type="button"
                    class="delete-btn"
                    (click)="removeStep(rowIndex, colIndex); $event.stopPropagation()">Excluir</button>
                  <button
                    *ngIf="step.status !== 'ATIVO'"
                    type="button"
                    class="icon"
                    (click)="removeStep(rowIndex, colIndex); $event.stopPropagation()">&times;</button>
                </div>
              </div>
              <label *ngIf="step.status !== 'ATIVO'">Ação
                <select
                  [(ngModel)]="step.type"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="handleTypeChange(step)">
                  <option *ngFor="let item of palette" [value]="item.type">{{ item.title }}</option>
                </select>
              </label>
              <div class="step-summary" *ngIf="step.status === 'ATIVO'">
                <div class="summary-item" *ngIf="step.type === 'tarefa'">
                  Tarefa: {{ getStepTitle(step) }}
                </div>
                <div class="summary-item" *ngIf="step.type === 'chamado'">
                  Chamado: {{ getStepTitle(step) }}
                </div>
                <div class="summary-item" *ngIf="step.type === 'email'">
                  Assunto: {{ getStepSubject(step) }}
                </div>
                <div class="summary-item">
                  Criado em: {{ getStepCreatedAt(step) | date:'short' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <aside class="action-panel">
        <ng-container *ngIf="selectedStep; else emptyPanel">
          <header class="panel-header">
            <div>
              <p>Configurar ação</p>
              <h3>{{ moduleLabel(selectedStep.type) }}</h3>
            </div>
            <button type="button" class="panel-close" (click)="clearSelection()">&times;</button>
          </header>

          <div class="panel-body" [ngSwitch]="selectedStep.type">
            <section *ngSwitchCase="'chamado'" class="panel-card">
              <header>
                <h4>Novo chamado</h4>
                <small>ControlHelp</small>
              </header>
              <form class="panel-form" (ngSubmit)="saveTicket()">
                <label>Título
                  <input
                    type="text"
                    placeholder="Resumo do chamado"
                    [(ngModel)]="ticketForm.title"
                    [ngModelOptions]="{ standalone: true }">
                </label>
                <label>Descrição
                  <textarea
                    rows="4"
                    placeholder="Detalhes do problema"
                    [(ngModel)]="ticketForm.description"
                    [ngModelOptions]="{ standalone: true }"></textarea>
                </label>
                <div class="form-grid">
                  <label>Prioridade
                    <select [(ngModel)]="ticketForm.priority" [ngModelOptions]="{ standalone: true }">
                      <option value="MEDIUM">Média</option>
                      <option value="HIGH">Alta</option>
                      <option value="LOW">Baixa</option>
                    </select>
                  </label>
                  <label>Departamento
                    <select
                      [(ngModel)]="ticketForm.department_id"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="onDepartmentChange()">
                      <option value="">Selecione um departamento</option>
                      <option *ngFor="let dept of departments" [value]="dept.id">{{ dept.name }}</option>
                    </select>
                  </label>
                  <label>Categoria
                    <select
                      [(ngModel)]="ticketForm.category"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="onCategoryChange()">
                      <option value="">Selecione a categoria</option>
                      <option *ngFor="let name of categoryOptions" [value]="name">{{ name }}</option>
                    </select>
                  </label>
                  <label>Subcategoria
                    <select [(ngModel)]="ticketForm.subcategory" [ngModelOptions]="{ standalone: true }">
                      <option value="">Selecione a subcategoria</option>
                      <option *ngFor="let name of subcategories" [value]="name">{{ name }}</option>
                    </select>
                  </label>
                </div>
                <div class="upload-box">
                  <strong>Adicionar anexos</strong>
                  <span>Arraste e solte aqui ou clique para selecionar</span>
                </div>
                <div class="panel-actions">
                  <div class="save-feedback" *ngIf="ticketSaved">Chamado salvo com sucesso.</div>
                  <button type="button" class="btn ghost">Cancelar</button>
                  <button type="submit" class="btn primary" [disabled]="savingTicket">
                    {{ savingTicket ? 'Salvando...' : 'Salvar chamado' }}
                  </button>
                </div>
              </form>
            </section>

            <section *ngSwitchCase="'tarefa'" class="panel-card">
              <header>
                <h4>Nova tarefa</h4>
                <small>ControlTask</small>
              </header>
              <form class="panel-form" (ngSubmit)="saveTask()">
                <label>Título
                  <input
                    type="text"
                    placeholder="Resumo da tarefa"
                    [(ngModel)]="taskForm.title"
                    [ngModelOptions]="{ standalone: true }">
                </label>
                <label>Descrição
                  <textarea
                    rows="3"
                    placeholder="Detalhes adicionais"
                    [(ngModel)]="taskForm.description"
                    [ngModelOptions]="{ standalone: true }"></textarea>
                </label>
                <div class="form-grid">
                  <label>Visibilidade
                    <select [(ngModel)]="taskForm.visibility" [ngModelOptions]="{ standalone: true }">
                      <option value="PRIVATE">Privada</option>
                      <option value="PUBLIC">Pública</option>
                    </select>
                  </label>
                  <label>Prioridade
                    <select [(ngModel)]="taskForm.priority" [ngModelOptions]="{ standalone: true }">
                      <option value="MEDIUM">Média</option>
                      <option value="HIGH">Alta</option>
                      <option value="LOW">Baixa</option>
                    </select>
                  </label>
                  <label>Início
                    <input type="date" [(ngModel)]="taskForm.start_date" [ngModelOptions]="{ standalone: true }">
                  </label>
                  <label>Vencimento
                    <input type="date" [(ngModel)]="taskForm.due_date" [ngModelOptions]="{ standalone: true }">
                  </label>
                </div>
                <div class="panel-actions">
                  <div class="save-feedback" *ngIf="taskSaved">Tarefa salva com sucesso.</div>
                  <button type="button" class="btn ghost">Cancelar</button>
                  <button type="submit" class="btn primary" [disabled]="savingTask">
                    {{ savingTask ? 'Salvando...' : 'Salvar tarefa' }}
                  </button>
                </div>
              </form>
            </section>

            <section *ngSwitchCase="'email'" class="panel-card">
              <header>
                <h4>Enviar e-mail</h4>
                <small>Comunicação automática</small>
              </header>
              <form class="panel-form" (ngSubmit)="saveEmail()">
                <div class="form-grid email-grid">
                  <label>Para
                    <input
                      type="text"
                      placeholder="cliente@empresa.com, outro@empresa.com"
                      [(ngModel)]="emailForm.to"
                      [ngModelOptions]="{ standalone: true }">
                  </label>
                  <label>Assunto
                    <input
                      type="text"
                      placeholder="Título da mensagem"
                      [(ngModel)]="emailForm.subject"
                      [ngModelOptions]="{ standalone: true }">
                  </label>
                </div>
                <div class="email-toolbar">
                  <button type="button" (click)="formatEmail('bold')">B</button>
                  <button type="button" (click)="formatEmail('italic')">I</button>
                  <button type="button" (click)="formatEmail('underline')">U</button>
                  <button type="button" (click)="formatEmail('insertUnorderedList')">•</button>
                  <button type="button" (click)="formatEmail('insertOrderedList')">1.</button>
                </div>
                <div
                  class="email-body"
                  contenteditable="true"
                  data-placeholder="Escreva sua mensagem..."
                  (input)="updateEmailBody($event)"
                  #emailBody></div>
                <div class="panel-actions">
                  <div class="save-feedback" *ngIf="emailSaved">E-mail salvo com sucesso.</div>
                  <button type="button" class="btn ghost">Cancelar</button>
                  <button type="submit" class="btn primary" [disabled]="savingEmail">
                    {{ savingEmail ? 'Salvando...' : 'Salvar e-mail' }}
                  </button>
                </div>
              </form>
            </section>

            <section *ngSwitchCase="'condicao'" class="panel-card">
              <header>
                <h4>Condição</h4>
                <small>Defina uma regra de decisão</small>
              </header>
              <form class="panel-form">
                <label>Nome da condição
                  <input type="text" placeholder="Ex: Aprovação financeira">
                </label>
                <label>Tipo
                  <select>
                    <option>Campo de formulário</option>
                    <option>Status</option>
                    <option>Prioridade</option>
                  </select>
                </label>
                <label>Valor esperado
                  <input type="text" placeholder="Ex: Aprovado">
                </label>
                <div class="panel-actions">
                  <button type="button" class="btn ghost">Cancelar</button>
                  <button type="button" class="btn primary">Salvar condição</button>
                </div>
              </form>
            </section>

            <section *ngSwitchDefault class="panel-card">
              <header>
                <h4>Etapa informativa</h4>
                <small>Configure os detalhes desta etapa.</small>
              </header>
              <p class="panel-text">Selecione uma ação na coluna da esquerda para visualizar o formulário correspondente.</p>
            </section>
          </div>
        </ng-container>
        <ng-template #emptyPanel>
          <div class="empty-panel">
            <h4>Selecione uma ação</h4>
            <p>Escolha uma etapa no fluxo para visualizar o formulário do ControlHelp, ControlTask ou e-mail.</p>
          </div>
        </ng-template>
      </aside>
    </div>
  </ng-template>
</section>
